import { PathOptions } from "leaflet";

export const subestacoes_base_existente = (feature: any): PathOptions => {
  // Black circle (existing substations)
  return {
    color: "#000000", // Black border
    weight: 1,
    opacity: 1,
    fillColor: "#000000", // Black fill
    fillOpacity: 1,
  };
};
